/* eslint-disable camelcase */
import { AutoMap } from "@automapper/classes";

export class TokenDto {
    @AutoMap() access_token!: string;
}